import * as React from 'react';
import { createPortal } from 'react-dom';

// Emplacement de la barre de menu, a cote du titre de la page, ou une page
// peut placer ses propres controles (ex : choix de l'athlete du calendrier)
// plutot que dans une ligne sous la barre, pour gagner de la hauteur.
const EmplacementBarre = React.createContext<HTMLElement | null>(null);

export const FournisseurEmplacementBarre = EmplacementBarre.Provider;

/** Affiche son contenu dans la barre de menu (rien tant qu'elle n'est pas montee). */
export const DansLaBarre = ({ children }: { children: React.ReactNode }) => {
  const emplacement = React.useContext(EmplacementBarre);
  return emplacement ? createPortal(children, emplacement) : null;
};
